import React, { useCallback, useState } from 'react';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { isUndefined, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import * as S from '../../../RelPitStopQuantidade/styles';

export default function Tabela({
  title,
  cells,
  data,
  height,
  size,
  onCallback,
}) {
  const [active, setActive] = useState({});

  const handleSetActiveItem = useCallback((item) => setActive(item), []);

  const handleSubmit = useCallback(
    (item) => {
      if (!isEmpty(item) && onCallback) {
        onCallback(item);
      }
    },
    [active, onCallback]
  );

  return (
    <S.WrapperTabela height={height}>
      <S.WrapperTitle>{title}</S.WrapperTitle>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size={size}>
          <TableHead>
            <TableRow>
              {cells.map((cell, index) => (
                <TableCell
                  key={`cell-index-head-${index}`}
                  align={cell.align || 'left'}
                >
                  {cell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow
                hover
                tabIndex={-1}
                key={`table-row-body-${index}`}
                onClick={() => handleSetActiveItem(item)}
                onDoubleClick={() => handleSubmit(item)}
              >
                {cells.map((cell, indexKey) => {
                  let value = item[cell.id];
                  if (!isUndefined(cell.rule) && cell.rule(item)) {
                    value = (
                      <input
                        id={`input-${cell.id}-${index}`}
                        type="number"
                        defaultValue={item[cell.id]}
                        onKeyUp={({ target, key }) =>
                          key === 'Enter' &&
                          cell.callback(target.value, index, item)
                        }
                        onBlur={({ target }) =>
                          cell.callback(target.value, index, item)
                        }
                      />
                    );
                  } else if (cell.format) {
                    value = cell.format(item[cell.id]);
                  }

                  return (
                    <TableCell
                      key={`table-cell-body-${indexKey}`}
                      align={cell.align || 'left'}
                    >
                      {value}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTabela>
  );
}

Tabela.propTypes = {
  title: PropTypes.string.isRequired,
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      align: PropTypes.string,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  height: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  onCallback: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

Tabela.defaultProps = {
  height: '100%',
  size: 'medium',
  onCallback: false,
};
